// Better Auth additional-fields schema, shared between the server config
// (core/auth/server/config.ts) and the browser client (core/auth/client/auth-client.ts).
//
// Kept isomorphic on purpose: no server-only imports (Prisma, SendGrid, etc.)
// so the client bundle never pulls in server code, and no dependency on the
// composition root (@/lib/auth) so core/auth stays self-contained.

export const authUserAdditionalFields = {
  parent: {
    type: 'number',
    required: false,
    defaultValue: 0,
  },
  lastName: {
    type: 'string',
    required: false,
  },
  nick: {
    type: 'string',
    required: false,
  },
  phone: {
    type: 'string',
    required: false,
  },
  status: {
    type: 'boolean',
    required: false,
    defaultValue: true,
  },
  currency: {
    type: 'string',
    required: false,
    defaultValue: 'USD',
  },
} as const;

export const authSessionAdditionalFields = {
  country: {
    type: 'string',
    required: false,
    defaultValue: 'GLOBAL',
  },
} as const;
